module.exports = __webpack_public_path__ + "static/img/icon_class_book.b9d2d9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_book.png
// module id = Pxsn
// module chunks = 1